// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgSingleBed = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill={color}
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 4.75C5 3.784 5.784 3 6.75 3h6.5c.966 0 1.75.784 1.75 1.75v3.879c.61.504 1 1.267 1 2.121v4.5a.75.75 0 0 1-.75.75H14v.25a.75.75 0 0 1-1.5 0V16h-5v.25a.75.75 0 0 1-1.5 0V16H4.75a.75.75 0 0 1-.75-.75v-4.5c0-.854.39-1.617 1-2.121V4.75Zm1.5 3.261c.082-.007.166-.011.25-.011H7v-.25C7 6.784 7.784 6 8.75 6h2.5c.966 0 1.75.784 1.75 1.75V8h.25c.084 0 .168.004.25.011V4.75a.25.25 0 0 0-.25-.25h-6.5a.25.25 0 0 0-.25.25v3.261Zm5-.011v-.25a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25V8h3Zm1.75 1.5c.69 0 1.25.56 1.25 1.25v3.75h-9v-3.75c0-.69.56-1.25 1.25-1.25h6.5Z"
    />
  </svg>
)

export default SvgSingleBed
